export type PrivateSurface = null | "inline" | "dialog";
export type PrivateIdentity = {
  roomInstanceId: string;
  playerId: string | null;
  matchId: string | null;
  phaseId: string | null;
};
export type PrivateRevealState = {
  key: string;
  surface: PrivateSurface;
  presentation: "inline" | "dialog";
};
type Event =
  | { type: "cover" }
  | { type: "reveal"; key: string; surface: "inline" | "dialog" }
  | {
      type: "sync";
      key: string;
      presentation: "inline" | "dialog";
      conceal: boolean;
    };
export function privateIdentityKey(identity: PrivateIdentity) {
  return JSON.stringify([
    identity.roomInstanceId,
    identity.playerId,
    identity.matchId,
    identity.phaseId,
  ]);
}
export function reducePrivateReveal(
  state: PrivateRevealState,
  event: Event,
): PrivateRevealState {
  if (event.type === "cover")
    return state.surface === null ? state : { ...state, surface: null };
  if (event.type === "reveal")
    return {
      key: event.key,
      presentation: event.surface,
      surface: event.surface,
    };
  if (
    event.key !== state.key ||
    event.presentation !== state.presentation ||
    (event.conceal && state.surface !== null)
  )
    return { key: event.key, presentation: event.presentation, surface: null };
  return state;
}
